import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Method from "./pages/Method";
import Services from "./pages/Services";
import Results from "./pages/Results";
import Reviews from "./pages/Reviews";
import CeramicCoating from "./pages/CeramicCoating";
import PaintCorrection from "./pages/PaintCorrection";
import InteriorDetailing from "./pages/InteriorDetailing";
import MobileDetailing from "./pages/MobileDetailing";
import Booking from "./pages/Booking";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              {/* Main Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/method" element={<Method />} />
              <Route path="/services" element={<Services />} />
              <Route path="/results" element={<Results />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Service-Specific Pages */}
              <Route path="/ceramic-coating" element={<CeramicCoating />} />
              <Route path="/paint-correction" element={<PaintCorrection />} />
              <Route path="/interior-detailing" element={<InteriorDetailing />} />
              <Route path="/mobile-detailing" element={<MobileDetailing />} />
              
              {/* Legal Pages */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Redirects for Broken/Old Routes */}
              <Route path="/the-method" element={<Navigate to="/method" replace />} />
              <Route path="/auto-detailing-1" element={<Navigate to="/services" replace />} />
              <Route path="/gallery" element={<Navigate to="/results" replace />} />
              <Route path="/gallery-reviews" element={<Navigate to="/results" replace />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
